// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 145) return "static/chunks/145-3f75a9ea383f3706.js";
	if (chunkId === 373) return "static/chunks/373-15fb3fcec106fec7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"42":"48c01132d3fe4054","88":"d9eb10591b84fada","141":"7054784364adf635","694":"7e3249048eef5610"}[chunkId] + ".js";
};